// @flow
import React from 'react'

import { Option as ReactSelectOption } from 'react-select'

export type OptionProps = {
  option: {
    title: string,
    preferred: {
      index: string,
      count: number
    },
    value: string
  },
  children: string
}

export default class Option extends ReactSelectOption<OptionProps> {
  getCssStyle = (): Object => {
    return this.isLastOption()
      ? { borderBottom: '1px solid #856f64' }
      : {}
  }

  isLastOption = (): boolean => {
    return this.props.option.preferred && this.props.option.preferred.index === (this.props.option.preferred.count - 1)
  }

  isPreferredOption = (): boolean => {
    return !!this.props.option.preferred
  }

  render () {
    return (
      <div
        className={this.props.className}
        onMouseDown={this.handleMouseDown}
        onMouseEnter={this.handleMouseEnter}
        onMouseMove={this.handleMouseMove}
        title={this.props.option.title}
        style={this.getCssStyle()}
      >
        {
          this.isPreferredOption()
            ? <strong>{this.props.children}</strong>
            : <span>{this.props.children}</span>
        }
      </div>
    )
  }
}
